// extracted by mini-css-extract-plugin
module.exports = {"infoIconTooltip":"Screens_infoIconTooltip__2qmz9"};